// extracted by mini-css-extract-plugin
export default {"addCardContainer":"style_addCardContainer__FoXQ-","addCardInner":"style_addCardInner__n8GUY"};